import {
  LessonComponentStyle,
  RgbaColor
} from '../models/LessonComponentStyle';

import AssetService from '../../shared/services/AssetService';

export interface StyleMap {
  [key: string]: string;
}
export const getColorString = (value: RgbaColor) => {
  return value
    ? `rgba(${value.r}, ${value.g},${value.b},${value.a})`
    : 'transparent';
};

const getStyle = (input: Array<number>) => input.map((s) => `${s}px`).join(` `);

export const StyleFormatter = (
  lessonComponentSettings: LessonComponentStyle
) => {
  let style = {} as StyleMap;

  Object.entries(lessonComponentSettings).forEach(([key, value]) => {
    switch (key) {
      case 'backgroundColor':
        style = { ...style, backgroundColor: getColorString(value) };
        break;
      case 'backgroundImage':
        style = {
          ...style,
          backgroundImage: `url(${AssetService.getAssetUrl(value)}`,
          backgroundSize: '100%'
        };
        break;
      case 'padding':
        style = {
          ...style,
          padding: getStyle([
            value?.top || 0,
            value?.right || 0,
            value?.bottom || 0,
            value?.left || 0
          ])
        };
        break;
      case 'margin':
        style = {
          ...style,
          margin: getStyle([
            value?.top || 0,
            value?.right || 0,
            value?.bottom || 0,
            value?.left || 0
          ])
        };
        break;
      case 'border':
        style = {
          ...style,
          border: `${value?.width || 0}px ${
            value?.style || 'none'
          } ${getColorString(value?.color)}`
        };
        break;
      case 'corner':
        style = {
          ...style,
          borderRadius: getStyle([
            value?.topLeft || 0,
            value?.topRight || 0,
            value?.bottomRight || 0,
            value?.bottomLeft || 0
          ])
        };
        break;
      case 'shadow':
        style = {
          ...style,
          boxShadow: `${getStyle([
            value?.x || 0,
            value?.y || 0,
            value?.b || 0
          ])} ${getColorString(value?.color)}`
        };
    }
  });

  return style;
};